import { IMeshRowData } from "@pageBuilder/typings";
import { DomUtil } from "src/utils/dom-util";
import { CascadeDataCleanUpService } from "src/services/cascade-data-cleanup.service";

export class MeshRowRenderer {

    public createNew(id?: string): HTMLElement {
        const meshRow = document.createElement("div");
        meshRow.setAttribute("data-mesh-row", "");
        meshRow.classList.add("mesh-row");

        meshRow.id = id ?? DomUtil.generateElementId();

        return meshRow;
    }

    public render(element: HTMLElement, data: IMeshRowData | undefined): void {
        if (!data) {
            return;
        }

        const cleanData = CascadeDataCleanUpService.cleanUp(data);
        element.setAttribute("data-element-json", JSON.stringify(cleanData));

        element.classList.toggle("empty", data.isEmpty ?? false);
    }

    public getData(element: HTMLElement): IMeshRowData {
        const parsedData = JSON.parse(element.getAttribute("data-element-json")!) as IMeshRowData;
        return CascadeDataCleanUpService.cleanUp(parsedData);
    }

}
